import { Model } from '@vuex-orm/core';
import Availability from '@/models/Availability';
import Buildingable from '@/models/Buildingable';
import Illustration from '@/models/Illustration';
import Image from '@/models/Image';
import Imageable from '@/models/Imageable';
import Shape from '@/models/Shape';
import Residence from '@/models/Residence';
import Selector from '@/models/Selector';

export default class Building extends Model {
  static entity = 'buildings';

  static state() {
    return {
      selectedBuilding: 'all',
    };
  }

  static fields() {
    return {
      id: this.uid(),
      name: this.attr(''),
      slug: this.attr(null),
      count: this.attr(null),
      description: this.attr(null),
      url: this.attr(null),

      isSelected: this.boolean(false),
      singleImg: this.boolean(true),
      activeIllustrationId: this.attr(null),

      // Relationships
      availability_id: this.attr(null),
      availability: this.belongsTo(Availability, 'availability_id'),
      illustrations: this.morphedByMany(
        Illustration,
        Buildingable,
        'building_id',
        'buildingable_id',
        'buildingable_type'
      ),
      images: this.morphToMany(
        Image,
        Imageable,
        'image_id',
        'imageable_id',
        'imageable_type'
      ),
      shapes: this.morphMany(Shape, 'shapeable_id', 'shapeable_type'),
      residences: this.morphedByMany(
        Residence,
        Buildingable,
        'building_id',
        'buildingable_id',
        'buildingable_type'
      ),
      selector_id: this.attr(null),
      selector: this.belongsTo(Selector, 'selector_id'),
    };
  }

  static transformer(data) {
    const buildings = [];
    data.data.forEach(item => {
      const building = {};
      building.id = item.id;
      building.name = item.name;
      building.slug = item.slug;
      building.count = item.count;
      building.description = item.description;
      buildings.push(building);
    });
    return buildings;
  }

  static apiConfig = {
    dataTransformer: data => this.transformer(data),
  };

  static fetch(baseURL) {
    // TODO: Add paginated fetch.
    let url = '/wp-json/wp/v2/building?per_page=100';
    return this.api().get(url, {
      baseURL: baseURL,
    });
  }
}
